function isSameAsLoggedInUser({ input, state, output }) {
  let user = state.get('client.user')
  if (user._id === input.result.user._id) {
    output.true()
  } else {
    output.false()
  }
}

isSameAsLoggedInUser.outputs = ['true', 'false']

export default isSameAsLoggedInUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/isSameAsLoggedInUser.js